import gql from "graphql-tag";

export const MY_CAFETERIA_GET_REGULATION = gql`
  query getVBKRegulation {
    getVBKRegulation {
      _id
      filename
      createdAt
    }
  }
`;

export default MY_CAFETERIA_GET_REGULATION;
